import { HTMLAttributes, useEffect, useState } from 'react';
import { JoveGridItem } from '@jove-frontend/mui';
import { useJoveBreakpoint } from '@jove-frontend/uikit';
import { Box, Grid, Typography } from '@mui/material';
import clsx from 'clsx';

type BrokerClientsSayViewProps = HTMLAttributes<HTMLDivElement> & {
  info: {
    clientSayTitle: string;
    clientSayInfoList: Array<{
      famousQuotes: string;
      author: string;
      position: string;
      userIcon: string;
    }>;
  };
};

const BrokerClientsSayView = (props: BrokerClientsSayViewProps) => {
  const { className, info } = props;
  const { isMobileLayout } = useJoveBreakpoint();

  return (
    <Box className={clsx('flex flex-col items-center', className)}>
      <Box className={clsx('flex flex-col items-center', isMobileLayout ? 'w-full space-y-1' : 'w-[960px] space-y-5')}>
        <Typography variant="h4" className="text-primary-black text-center font-black">
          {info?.clientSayTitle}
        </Typography>
        <Grid container spacing={4}>
          {(info?.clientSayInfoList || []).map((item, index) => {
            return (
              <Grid key={index} item md={6}>
                <JoveGridItem key={index} className="h-full">
                  <Box className="flex h-full flex-col justify-between space-y-4 rounded-2xl bg-white p-6">
                    <Typography variant="h6" className="font-medium">
                      {item.famousQuotes}
                    </Typography>
                    <Box className="flex flex-row items-center space-x-6">
                      <img width={80} height={80} src={item.userIcon} alt="User icon" className="rounded-full" />
                      <Box className="flex flex-1 flex-col space-y-2">
                        <Typography variant="h5" className="text-dark-blue font-black">
                          {item.author}
                        </Typography>
                        <Typography variant="h6" className="text-primary-black font-medium">
                          {item.position}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </JoveGridItem>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
};

export default BrokerClientsSayView;
